/* eslint-disable react-hooks/exhaustive-deps */
import ModalConfirmation from '../CustomModal/ModalConfirmation';
import AvatarInCall from './AvatarInCall';
import StreamChatPanel from './StreamChatPanel';
import StreamFooter from './StreamFooter';
import StreamInforPanel from './StreamInforPanel';
import StreamSharingPanel from './StreamSharingPanel';
import './styles.scss';
import AgoraInstanceTelecounsel from '@/agora/agoraInstanceTelecounsel';
import { EndCallIcon, MicroOffOutline } from '@/assets/svg';
import { isFirefox } from '@/helpers';
import { endCall } from '@/helpers/telecounsellingRoomSignalR';
import { useContainerDimensions } from '@/helpers/useHookHelpers';
import { ModalUI } from '@/module/common';
import teleQueueRoomDispatcher from '@/module/telecounsel-queue/action';
import { Box, CircularProgress, Drawer, Fab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { isEmpty, upperCase } from 'lodash';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

const useStyles = makeStyles({
  paper: {
    width: (props) => `calc(100% - ${props.modalWidth}px)`,
    height: '100%',
    top: 0,
    left: 0,
    transition: 'width 0.2s',
    position: 'relative',
    borderRadius: 'unset',
    backgroundColor: '#333333',

    padding: (props) =>
      props.isSharing
        ? props.showNRIC || props.showChat
          ? '20px'
          : `20px 0 20px 20px`
        : `unset`,
    display: (props) => (props.isSharing ? 'flex' : 'block'),
  },

  sharingContainerShowNIRIC: {
    width: 429,
    overflow: 'hidden',
    backgroundColor: '#333333',
    right: '429px',
    borderLeft: 'unset',
  },

  chatContainer: {
    width: 429,
    overflow: 'hidden',
  },

  sharingContainer: {
    width: 365,
    overflow: 'hidden',
    backgroundColor: '#333333',
    borderLeft: 'unset',
  },
  loadingWrapper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  btn: {
    width: 56,
    height: 56,
    backgroundColor: 'white',
    borderRadius: 4,
    boxShadow: 'none',
    zIndex: 1,
  },
});

const StreamInCallPanel = ({
  remoteStreams,
  localStream,
  isMuteVideo,
  isMuteAudio,
  isMuteSpeaker,
  isPatientMuteAudio,
  isPatientMuteVideo,
  patientId,
  videoChannelId,
  isSharing,
  showChat,
  currentUser,
  channelInfo,
  partner,
  updateListChannels,
  verifyingUserData,
  doVerify,
  showNRIC,
  showSharing,
  startCallTime,
  debounceLoadData,
}) => {
  const [modalWidth, setModalWidth] = useState(showChat ? 429 : 0);
  const [hasNewMessage, setHasNewMessage] = useState(false);

  const [chatChannel, setChatChannel] = useState({});
  const [endModal, setEndModal] = useState(false);

  const classes = useStyles({ modalWidth, isSharing, showNRIC, showChat });

  let mainStreamRef = useRef(null);
  const [, , ratio] = useContainerDimensions(mainStreamRef);

  useEffect(() => {
    AgoraInstanceTelecounsel.instance.joinChannel(videoChannelId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => {
      // clean up memberAppointment
      teleQueueRoomDispatcher.setState('memberAppointment', null);
    };
  }, []);

  useEffect(() => {
    if (channelInfo) {
      setChatChannel(channelInfo);
    }
    // else createNewChannel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelInfo]);

  const handleToggleChatMessage = () => {
    setModalWidth(!showChat ? 429 : 0);
    teleQueueRoomDispatcher.setState('showChat', !showChat);
    showNRIC && teleQueueRoomDispatcher.setState('showNRIC', !showNRIC);
    isSharing && setModalWidth(!showChat ? 429 : 0);

    setHasNewMessage(false);
  };

  const handleToggleNRIC = () => {
    setModalWidth(!showNRIC ? 429 : 0);
    teleQueueRoomDispatcher.setState('showNRIC', !showNRIC);
    showChat && teleQueueRoomDispatcher.setState('showChat', !showChat);
    showSharing && setModalWidth(!showNRIC ? 429 : 0);
  };

  const handleToggleShowSharingPanel = (isSharing) => {
    setModalWidth(0);
    teleQueueRoomDispatcher.setState('showSharing', isSharing);
    showChat && teleQueueRoomDispatcher.setState('showChat', !showChat);
    showNRIC && teleQueueRoomDispatcher.setState('showNRIC', !showNRIC);
  };

  const handleRotateScreen = useCallback(
    (isCheck) => {
      const { DeviceType } = verifyingUserData;
      let transform = '';
      let operator = DeviceType === 'Android' ? '-' : '';
      let degree = DeviceType === 'Android' ? 90 : 0;

      if (isFirefox() && isCheck) {
        transform = `translate(-50%, -50%) rotate(${operator}${degree}deg)`;
      } else transform = '';

      return transform;
    },
    [verifyingUserData]
  );

  useEffect(() => {
    handleToggleShowSharingPanel(isSharing);
  }, [isSharing]);

  return (
    <ModalUI {...{ open: true, classes }}>
      <Box
        width="100%"
        height="100%"
        borderRadius={16}
        display={isSharing ? 'flex' : 'block'}
        bgcolor={
          isSharing
            ? showNRIC || showChat
              ? '#66666666'
              : '#333333'
            : '#e2f2ff'
        }
      >
        <Box
          width="100%"
          height="100%"
          borderRadius={16}
          border={`1px solid  ${
            isSharing
              ? showNRIC || showChat
                ? 'transparent'
                : '#979797'
              : '#e2f2ff'
          }`}
          bgcolor={
            isSharing
              ? showNRIC || showChat
                ? 'transparent'
                : '#66666666'
              : '#e2f2ff'
          }
        >
          <StyledContainer
            ref={mainStreamRef}
            key="main_stream"
            id="main_stream"
            showNRIC={showNRIC}
            showChat={showChat}
            isSharing={isSharing}
            transform={handleRotateScreen(!isSharing)}
          >
            {isPatientMuteAudio && (
              <Box position="absolute" top={30} right={40}>
                <Fab className={classes.btn}>
                  <MicroOffOutline color={'#ad5e99'} />
                </Fab>
              </Box>
            )}
            {isEmpty(remoteStreams) ? (
              <Box className={classes.loadingWrapper}>
                <CircularProgress color="secondary" />
              </Box>
            ) : (
              <Box
                position="absolute"
                top="50%"
                left="50%"
                style={{
                  transform: 'translate(-50%, -50%)',
                  backgroundColor: '#e2f2ff',
                }}
              >
                <AvatarInCall>
                  <Box
                    color={'#e2f2ff'}
                    fontFamily="Lato"
                    fontSize={
                      (
                        verifyingUserData?.FullName ||
                        verifyingUserData.PatientFullName
                      )
                        ?.match(/\b\w/g)
                        .join('').length > 4
                        ? 36
                        : 48
                    }
                    fontWeight={700}
                  >
                    {upperCase(
                      (
                        verifyingUserData?.FullName ||
                        verifyingUserData.PatientFullName
                      )
                        ?.match(/\b\w/g)
                        .join('')
                    )}
                  </Box>
                </AvatarInCall>
              </Box>
            )}
          </StyledContainer>
        </Box>

        {isSharing && (
          <StreamSharingPanel
            data={verifyingUserData}
            partner={partner}
            isMuteVideo={isMuteVideo}
            transform={handleRotateScreen(!isSharing)}
            bgcolor={
              isSharing && (showChat || showNRIC) ? 'transparent' : '#333333'
            }
            height={
              isSharing && (showChat || showNRIC)
                ? 'calc(100% - 146px)'
                : 'unset'
            }
          />
        )}
      </Box>
      <StreamFooter
        isMuteAudio={isMuteAudio}
        isMuteSpeaker={isMuteSpeaker}
        isMuteVideo={isMuteVideo}
        isPatientMuteVideo={isPatientMuteVideo}
        verifyingUserData={verifyingUserData}
        transform={handleRotateScreen(!isSharing)}
        videoChannelId={videoChannelId}
        isSharing={isSharing}
        showChat={showChat}
        showNRIC={showNRIC}
        setEndModal={setEndModal}
        handleToggleChatMessage={handleToggleChatMessage}
        handleToggleNRIC={handleToggleNRIC}
        startCallTime={startCallTime}
        hasNewMessage={hasNewMessage}
      />

      {endModal && (
        <ModalConfirmation
          open={!!endModal}
          onClose={() => setEndModal(false)}
          mainContent="End call"
          subContent="Are you sure you want to end this call?"
          onClick={async () => {
            await endCall(patientId);
            AgoraInstanceTelecounsel.instance.leaveChannel({
              leaveOnlyShareScreen: false,
            });
            debounceLoadData();
          }}
          confirmLabel="Confirm"
          Icon={<EndCallIcon />}
          style={{ paddingLeft: 16, paddingRight: 16 }}
        />
      )}

      <Drawer
        open={showChat}
        anchor="right"
        variant="persistent"
        classes={{ paper: classes.chatContainer }}
        onClose={handleToggleChatMessage}
      >
        <StreamChatPanel
          setChatChannel={setChatChannel}
          updateListChannels={updateListChannels}
          partner={partner}
          isOpen={showChat}
          channelInfo={chatChannel}
          onClose={handleToggleChatMessage}
          setHasNewMessage={setHasNewMessage}
        />
      </Drawer>

      {showNRIC && (
        <Drawer
          open={showNRIC}
          anchor="right"
          variant="persistent"
          classes={{ paper: classes.chatContainer }}
          onClose={handleToggleNRIC}
        >
          <StreamInforPanel
            onClose={handleToggleNRIC}
            data={verifyingUserData}
            partner={partner}
          />
        </Drawer>
      )}
    </ModalUI>
  );
};

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: ${(props) => (props.isSharing ? `calc(100% - 146px)` : `unset`)};
  position: relative;
  padding: ${(props) => (props.isSharing ? `20px 40px 0` : `unset`)};

  padding: ${(props) =>
    props.isSharing
      ? props.showNRIC || props.showChat
        ? `20px 0 0 40px`
        : `20px 40px 0`
      : `unset`};

  div:nth-child(2) {
    background-color: #333333;
    border-radius: 16px;
  }

  video {
    height: ${(props) => (props.isSharing ? `100%` : `200%`)} !important;
    transform: ${(props) =>
      !isEmpty(props.transform) ? props.transform : 'translate(-50%, -50%)'};

    top: 50% !important;
    left: 50% !important;
  }
`;

const mapStateToProps = (state) => {
  const {
    localStream,
    remoteStreams,
    isMuteAudio,
    isMuteVideo,
    isMuteSpeaker,
    isPatientMuteAudio,
    isSharing,
    showChat,
    showNRIC,
    showSharing,
    verifyingUserData,
    isPatientMuteVideo,
    startCallTime,
  } = state.teleQueueRoom;
  return {
    localStream,
    remoteStreams,
    isMuteAudio,
    isMuteVideo,
    isMuteSpeaker,
    isPatientMuteAudio,
    isSharing,
    showChat,
    showNRIC,
    showSharing,
    verifyingUserData,
    isPatientMuteVideo,
    startCallTime,
  };
};

export default connect(mapStateToProps)(StreamInCallPanel);
